export default __webpack_public_path__ + "static/media/custom_select.ffd20a9c.svg";